import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { OutputMessageProps } from "./types";
import { ButtonText } from "../Button";

const OutputMessage: React.FC<OutputMessageProps> = ({
  status,
  onClick,
  buttonText,
  descriptionText,
  icon,
  labelText,
  title
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      { title && (
        <Typography
          color="primary"
          fontSize={ isMobile ? "1.25rem" : "2rem" }
          fontWeight={ 700 }
          lineHeight={ isMobile ? (21 / 20) : (19 / 16) }
        >
          { title }
        </Typography>
      ) }
      <Box
        sx={ {
          display: "flex",
          justifyContent: "center",
          my: "30px"
        } }
      >
        <Box
          component="img"
          role="img"
          src={ icon }
          alt="Icon"
          width={ 80 }
          height={ 80 }
          loading="lazy"
        />
      </Box>
      <Typography
        variant="h4"
        sx={ {
          mb: "10px",
          textAlign: "center"
        } }
      >
        { labelText }
      </Typography>
      { descriptionText && (
        <Typography
          variant="h6"
          sx={ {
            mb: "10px",
            textAlign: "center"
          } }
        >
          { descriptionText }
        </Typography>
      ) }
      { status && (
        <Stack
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
          mt={ 3 }
          sx={ { marginTop: "30px", mx: "auto", width: "65%" } }
        >
          <ButtonText
            variant="outlined"
            onClick={ onClick  && onClick }
          >
            { buttonText }
          </ButtonText>
        </Stack>
      ) }
    </>
  );
};

export default OutputMessage;
